import { ReactElement } from "react";
import { useStorefrontLinkList } from "../../../../hooks/api/v2/storefrontLink/useStorefrontLinkList";
import { useSellarCurrentBusiness } from "../../../../hooks/useSellarCurrentBusiness.shared";
import { DialogContent } from "../../../modal/Dialog";
import { SpinnerLegacy } from "../../..";
import { SharePricingDialogDeactivatePageContent } from "./SharePricingDialogDeactivatePageContent";
import { SharePricingSource } from "./SharePricingDialogTypes";

export function SharePricingDialogDeactivatePage({
  priceTierId,
  source,
  connectionId,
  onDismiss,
}: {
  priceTierId?: number | null;
  connectionId?: number | null;
  source: SharePricingSource;
  onDismiss?: () => void;
}): ReactElement {
  const { business } = useSellarCurrentBusiness();
  const hasPriceTierOrConnectionId = !!priceTierId || !!connectionId;
  const storefrontLinkListQuery = useStorefrontLinkList(
    {
      query: [
        ...(priceTierId
          ? ([
              {
                type: "PriceTierId",
                value: priceTierId,
                modifier: "EQUALS",
              },
            ] as const)
          : []),
        ...(connectionId
          ? ([
              {
                type: "ConnectionId",
                value: connectionId,
                modifier: "EQUALS",
              },
            ] as const)
          : []),
      ],
    },
    { enabled: !!business?.Supplier && hasPriceTierOrConnectionId },
  );

  if (priceTierId && connectionId)
    throw new Error(
      "Can not create link with both price tier and connection ids",
    );

  const storefrontLink = storefrontLinkListQuery.data?.pages[0]?.[0];

  return (
    <>
      <DialogContent className={"flex h-full flex-col"}>
        {storefrontLinkListQuery.isLoading ? (
          <SpinnerLegacy />
        ) : (
          <>
            {storefrontLink?.id && (
              <SharePricingDialogDeactivatePageContent
                storefrontLinkId={storefrontLink.id}
                source={source}
                onDismiss={onDismiss}
              />
            )}
          </>
        )}
      </DialogContent>
    </>
  );
}
